export default __webpack_public_path__ + "static/media/address.a21d75ba.svg";